import React, { useEffect, useState } from "react";
import axiosAuth from "../api/axiosAuth";
import { API } from "../components/config";
import { useAuth } from "../context/AuthContext";
import "../style/DashboardProfesor.css";

export default function PerfilProfesor() {
  const { token, user } = useAuth();

  const [profesor, setProfesor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token || !user?.id) return;

    let isMounted = true;

    const fetchResumen = async () => {
      try {
        setLoading(true);
        setError("");

        // 🔥 usando API centralizada
        const endpoint = `${API}/profesor/resumen/${user.id}`;

        const res = await axiosAuth.get(endpoint);

        if (isMounted) {
          setProfesor(res.data.profesor);
        }
      } catch (err) {
        console.error("❌ Error cargando resumen del profesor:", err);

        if (!isMounted) return;

        setError(
          err.response?.data?.msg ||
          "No se pudo cargar la información del profesor."
        );
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchResumen();

    return () => {
      isMounted = false;
    };
  }, [token, user]);

  // 🔄 LOADING
  if (loading) {
    return <p className="loading-msg">Cargando información...</p>;
  }

  // ❌ ERROR
  if (error) {
    return <p className="error-msg">{error}</p>;
  }

  // ⚠️ NO DATA
  if (!profesor) {
    return <p className="error-msg">Profesor no encontrado</p>;
  }

  return (
    <div className="dashboard-profesor">
      <div className="perfil-card">

        {/* HEADER */}
        <div className="perfil-header">
          <div className="avatar">
            {profesor.nombre?.[0]}
            {profesor.apellido?.[0]}
          </div>

          <h2>
            {profesor.nombre} {profesor.apellido}
          </h2>

          <p className="role">
            {profesor.role || "Profesor"}
          </p>
        </div>

        {/* INFO */}
        <div className="perfil-info">
          <p>
            <strong>Email:</strong> {profesor.email || "No disponible"}
          </p>

          <p>
            <strong>Documento:</strong> {profesor.documento || "No disponible"}
          </p>

          <p>
            <strong>Teléfono:</strong> {profesor.telefono || "No disponible"}
          </p>

          <p>
            <strong>Sede:</strong> {profesor.nombre_sede || "No disponible"}
          </p>
        </div>

      </div>
    </div>
  );
}
